import React, { useState } from "react";
import { Button } from "primereact/button";
import { useToast } from "../../utils/toast";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import calistayServices from "../../services/calistay/calistay.service";
import { Item, SortedItemAnket1 } from "../../services/calistay/calistay.dto";

const initialItems = [
  { id: "1", name: "İnovasyon ve Yeni Ürün Geliştirme" },
  { id: "2", name: "Uluslararasılaşma ve Pazar Genişletme" },
  { id: "3", name: "Sürdürülebilirlik ve Yeşil İş Modelleri" },
  { id: "4", name: "Dijital Dönüşüm ve Teknoloji Kullanımı" },
  { id: "5", name: "Tedarik Zinciri Yönetimi ve Lojistik Optimizasyonu" },
  { id: "6", name: "İş Birliği ve Kümelenme" },
  { id: "7", name: "Pazar Araştırması ve Müşteri İlişkileri Yönetimi (CRM)" },
  { id: "8", name: "E-Ticaret ve Dijital Pazarlama Stratejileri" },
  { id: "9", name: "Yatırım ve Finansal Yönetim" },
  { id: "10", name: "İşgücü Gelişimi ve Yetenek Yönetimi" },
  { id: "11", name: "Kalite Yönetim Sistemleri ve Standartlara Uyum" },
  { id: "12", name: "Maliyet Yönetimi ve Operasyonel Verimlilik" },
  { id: "13", name: "Stratejik Planlama ve Risk Yönetimi" },
  { id: "14", name: "Müşteri Deneyimi ve Hizmet Kalitesi" },
  { id: "15", name: "Girişimcilik Destek Programları" }
];

const CalistayAnketSirala4 = () => {
  const toast = useToast();

  const [items, setItems] = useState<Item[]>(initialItems);

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const { source, destination } = result;
    const reorderedItems = [...items];
    const [removed] = reorderedItems.splice(source.index, 1);
    reorderedItems.splice(destination.index, 0, removed);
    setItems(reorderedItems);
  };

  const handleSubmit = async () => {
    try {
      let masaNo = undefined;

      if (masaNo) {
        const dto: SortedItemAnket1 = {
          masaNo: masaNo,
          result1: items[0].name,
          result2: items[1].name,
          result3: items[2].name,
          result4: items[3].name,
          result5: items[4].name,
          result6: items[5].name,
          result7: items[6].name,
          result8: items[7].name,
          result9: items[8].name,
          result10: items[9].name,
          result11: items[10].name,
          result12: items[11].name,
          result13: items[12].name,
          result14: items[13].name,
          result15: items[14].name,
          result16: items[15] ? items[15].name : ""
        };

        calistayServices
          .AnketSirala4(dto)
          .then((res) => {
            if (res?.result?.error === null) {
              toast.show("Form başarıyla kaydedildi!", "success");
            } else {
              toast.show("Form gönderiminde hata oluştu.", "error");
            }
          })
          .catch((error) => {
            toast.show("Sunucu hatası: " + error.message, "error");
          });
      }
    } catch (error) {
      console.error(error);
      toast.show("Bir hata oluştu. Lütfen tekrar deneyin.", "error");
    }
  };
  const addNewItem = () => {
    if (!newItemName) {
      toast.show("Lütfen bir değer girin.", "error");
      return;
    }

    const newItem = { id: String(items.length + 1), name: newItemName }; // Generate a new ID
    setItems([...items, newItem]); // Add the new item to the list
    setNewItemName(""); // Clear the input field
    setItemAdded(true); // Mark that an item has been added
    toast.show("Yeni madde başarıyla eklendi!", "success");
  };
  const [newItemName, setNewItemName] = useState<string>(""); // State for the new item name
  const [itemAdded, setItemAdded] = useState<boolean>(false);

  return (
    <div className="card ">
      <h5 className="text-center mb-4 font-medium">İş Geliştirme Stratejik Amaçlar</h5>

      <div className="flex justify-center p-0 md:p-4">
        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="droppable-source">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                className="w-full bg-gray-100 p-2 md:p-4 rounded"
              >
                <h5 className="mb-4 font-medium">Sıralama Alanı</h5>
                {items.map(({ id, name }, index) => (
                  <Draggable key={id} draggableId={id} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="p-2 mb-2 bg-white rounded border border-gray-200 flex items-center"
                      >
                        <span className="mr-2 md:mr-4">{index + 1}.</span> {/* Sıra numarası */}
                        {name}
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <div className="mt-3 flex flex-column sm:flex-row gap-2 justify-content-end">
        <input
          type="text"
          value={newItemName}
          onChange={(e) => setNewItemName(e.target.value)}
          placeholder="Yeni madde adı"
          className="p-inputtext p-component flex-1 sm:w-20rem"
        />
        <Button label="Ekle" icon="pi pi-plus" onClick={addNewItem} disabled={itemAdded} />
      </div>

      {/* <div className="m-2 md:m-3 mt-4" style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button label="Kaydet" onClick={handleSubmit} />
      </div> */}
    </div>
  );
};

export default CalistayAnketSirala4;
